import React, { ReactNode, JSX } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ModalBody } from 'reactstrap';
import classNames from 'classnames';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Modal = require('react-modal');

export interface Props {
  isOpen: boolean;
  toggle: () => void;
  children: ReactNode | ReactNode[];
  closeOnBackdrop?: boolean;
  additionalClass?: string;
}

const ModalLayer = (props: Props): JSX.Element => {
  const { isOpen, toggle, children, additionalClass, closeOnBackdrop = true } = props;

  return (
    <div className="information-layer">
      <Modal
        overlayClassName={`information-layer__modal__container cmb ${
          closeOnBackdrop ? 'information-layer__modal__container--pointer' : ''
        }`}
        className={classNames('information-layer__modal', additionalClass || '')}
        ariaHideApp={false}
        isOpen={isOpen}
        onAfterClose={(): void => {
          document.body.classList.remove('ReactModal__Body--open');
        }}
      >
        <ModalBody>
          <div className="information-layer__modal__close__container">
            <button className="bg-transparent border-0 p-0">
              <FontAwesomeIcon
                onClick={toggle}
                className="information-layer__modal__close"
                icon={faTimes}
              />
            </button>
          </div>
          {children}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModalLayer;
